import React from 'react'
import "./IconButton.css"

function IconButton({ icon = "edit" ,onClick=()=>{}}) {
  return (
    <div className='icon-button__main' onClick={(e)=>onClick(e)}>
      <span class="material-symbols-outlined">
        {icon}
      </span>
    </div>
  )
}

export default IconButton


// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/Buttons/IconButton.js